import { Box, IconButton, Slide, Typography } from "@mui/material";
import StyledBaseDialog from "./BaseDialog.styled";
import { forwardRef, useImperativeHandle, useState } from "react";
import { MdClose } from "react-icons/md";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// eslint-disable-next-line react/display-name
const BaseDialog = forwardRef(
  (
    {
      maxWidth = "xs",
      title = "",
      closeButton = true,
      children,
      preventClose = false,
    },
    ref
  ) => {
    const [open, setOpen] = useState(false);
    useImperativeHandle(ref, () => ({
      openModal: () => {
        setOpen(true);
      },
      closeModal: (event, reason) => {
        if (preventClose) {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            setOpen(false);
          }
        } else {
          setOpen(false);
        }
      },
    }));

    return (
      open && (
        <StyledBaseDialog
          maxWidth={maxWidth}
          fullWidth
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={(event, reason) => ref.current.closeModal(event, reason)}
          aria-describedby="alert-dialog-slide-description"
          disableEscapeKeyDown={preventClose}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 2,
              py: 1,
            }}
          >
            <Typography fontWeight={500} color="text.secondary">
              {title}
            </Typography>
            {closeButton && (
              <IconButton onClick={() => ref.current.closeModal()}>
                <MdClose size={20} />
              </IconButton>
            )}
          </Box>
          {children}
        </StyledBaseDialog>
      )
    );
  }
);

export default BaseDialog;
